import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { inputCls, PageHead } from "./ui";

export default function AdminAudit() {
  const { isOwner } = useAuth();
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (!isOwner) return;
    const id = setTimeout(() => api.get("/admin/audit", { params: { q: q || undefined, limit: 200 } }).then((r) => setLogs(r.data)), 250);
    return () => clearTimeout(id);
  }, [q, isOwner]);
  if (!isOwner) return <Navigate to="/admin" replace />;
  return (
    <div data-testid="admin-audit">
      <PageHead title="Registro attività" subtitle="Modifiche importanti effettuate nel pannello">
        <input data-testid="audit-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca" className={inputCls} />
      </PageHead>
      <ul className="bg-white/60 border border-[#D5B98C]/50 divide-y divide-[#D5B98C]/40 text-sm">
        {logs.map((l) => (
          <li key={l.id} data-testid="audit-row" className="p-3 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
            <span className="text-xs text-[#242321]/55 sm:w-40 shrink-0">{new Date(l.at).toLocaleString("it-IT")}</span>
            <span className="flex-1"><b>{l.action}</b>{l.details && <span className="text-[#242321]/65"> · {l.details}</span>}</span>
            <span className="text-xs text-[#956842]">{l.user_email}</span>
          </li>
        ))}
        {logs.length === 0 && <li className="p-4 text-[#242321]/55">Nessuna attività.</li>}
      </ul>
    </div>
  );
}
